module.exports = __webpack_public_path__ + "static/img/product_images_41_h5_zh.2f0234d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_images_41_h5_zh.png
// module id = aSGs
// module chunks = 34